import React, { FunctionComponent, useState } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import Text from 'common/components/Text/Text';
import styles from './BackofficeLogin.module.scss';
import { BackofficeUser, CommonHash } from 'app/types';
import GoogleIcon from 'assets/session/google_icon.svg';
import { useAddBackofficeLoginMutation } from 'services/exploreApi';
import { loginSuccess } from './backofficeSlice';
import { useAppDispatch } from 'app/hooks';
import { useNavigate } from 'react-router-dom';
import { Logo } from 'assets/landing/index';

interface CompProps {
  googleSuccess: boolean;
  setGoogleSuccess?: (a: boolean) => void;
  setAdminData: (a: CommonHash) => void;
}

const BackofficeLogin: FunctionComponent = () => {
  const [loginBackofficeUser] = useAddBackofficeLoginMutation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const googleLogin = useGoogleLogin({
    onSuccess: async (response) => {
      const data = { provider: 'google_oauth2', token: response.access_token };
      loginBackofficeUser({ user: data }).then((resp: CommonHash) => {
        const backofficeUser = {
          ...resp.data.response,
          accessToken: resp.data.auth,
        } as BackofficeUser;
        dispatch(loginSuccess({ backofficeUser }));
        navigate('/backoffice/dashboard');
      });
    },
  });

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <img src={Logo} alt="logo" className={styles.logoContainer} />
        <Text size={30} weight={700}>
          Unify&apos;s Backoffice
        </Text>
        <div className={styles.googleButton} onClick={() => googleLogin()}>
          <img src={GoogleIcon} alt="google_icon" className={styles.googleIcon} />
          <Text size={14} weight={500}>
            Log in with Google
          </Text>
        </div>
      </div>
    </div>
  );
};

export default BackofficeLogin;
